// Cookie banner + tags (server side: web/tracking.py) - as TrumpfBlatt, without Google Ads.
//
// The banner is vanilla-cookieconsent, bundled here - nothing from a third party
// loads before the visitor says yes. Consent Mode v2 "basic": gtag.js, Clarity
// and the Meta pixel are added to the page only once their category is accepted;
// taking a category back deletes its cookies and reloads the page.
//
//   analytics   Google Analytics 4 (no Google signals, no ad personalisation),
//               Microsoft Clarity (heatmaps, recordings - book, wizard, account, checkout masked)
//   marketing   the Meta pixel (only with an id - cfg.meta; autoConfig off)
//
// track(name, params) takes GA4's event names and sends each where it belongs (Meta: META_EVENTS).
// Events a page names in the view (json "tracking-events": view_item, begin_checkout, purchase) go
// out once the tags are there, also when the yes comes later on the same page. Never personal data.
// Locally (DEBUG, no ids) the config is "dry": the banner as live, nothing loaded, events logged.
var CookieConsent = require('vanilla-cookieconsent');     // the UMD build

var json = function (id) {
  var el = document.getElementById(id);
  try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
};

var cfg = json('tracking-config');
var pageEvents = json('tracking-events') || [];
var pageSent = { ga4: false, clarity: false, meta: false };     // which tag got this page's events
var on = { analytics: false, marketing: false };
var ready = { ga4: false, clarity: false, meta: false };

// GA4 name -> Meta standard event (anything else is GA4 only)
var META_EVENTS = { view_item: 'ViewContent', begin_checkout: 'InitiateCheckout', purchase: 'Purchase' };

// children's faces, names, photos, addresses: Clarity never records these areas
var MASKED = ['[data-book]', '[data-reader]', '[data-wizard]', '[data-checkout]', '[data-clarity-mask]', 'main.account'];
var maskPrivate = function () {
  var path = location.pathname;
  if (/^\/(buch|erstellen|konto|kasse|kontakt|vertrag-widerrufen)\//.test(path)) {
    document.querySelectorAll('main').forEach(function (el) { el.setAttribute('data-clarity-mask', 'true'); });
  }
  MASKED.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) { el.setAttribute('data-clarity-mask', 'true'); });
  });
};

var addScript = function (src) {
  if (cfg.dry) { console.info('[tracking] lokal, nicht geladen:', src); return; }
  var s = document.createElement('script');
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
};

var loadGa4 = function () {
  if (ready.ga4) return;
  ready.ga4 = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('consent', 'default', {
    analytics_storage: 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied',
  });
  window.gtag('consent', 'update', { analytics_storage: 'granted' });       // only called after the yes
  window.gtag('js', new Date());
  window.gtag('config', cfg.ga4, { allow_google_signals: false, allow_ad_personalization_signals: false });
  addScript('https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(cfg.ga4));
};

var loadClarity = function () {
  if (ready.clarity) return;
  ready.clarity = true;
  maskPrivate();
  // Clarity's standard loader, unrolled: it queues calls until the script is there
  window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
  addScript('https://www.clarity.ms/tag/' + encodeURIComponent(cfg.clarity));
  // EEA visitors: without this signal Clarity records cookieless (no returning visitors); no ads
};

var loadMeta = function () {
  if (ready.meta) return;
  ready.meta = true;
  // the pixel's own loader, unrolled
  var fbq = window.fbq = function () {
    if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments); else fbq.queue.push(arguments);
  };
  if (!window._fbq) window._fbq = fbq;
  fbq.push = fbq; fbq.loaded = true; fbq.version = '2.0'; fbq.queue = [];
  addScript('https://connect.facebook.net/en_US/fbevents.js');
  // no automatic event detection / page metadata scraping - only what we send (privacy text);
  // "automatic advanced matching" must also stay off in Events Manager
  fbq('set', 'autoConfig', false, cfg.meta);
  fbq('init', cfg.meta);
  fbq('track', 'PageView');
};

var apply = function () {
  on.analytics = (!!cfg.ga4 || !!cfg.clarity) && CookieConsent.acceptedCategory('analytics');
  on.marketing = !!cfg.meta && CookieConsent.acceptedCategory('marketing');
  if (on.analytics && cfg.ga4) loadGa4();
  if (on.analytics && cfg.clarity) {
    loadClarity();
    // EEA visitors: without this signal Clarity records cookieless (no returning visitors);
    // ads only with the marketing consent
    window.clarity('consentv2', { ad_Storage: on.marketing ? 'granted' : 'denied', analytics_Storage: 'granted' });
  }
  if (on.marketing) loadMeta();
  // the page's own events go to every tag once - also to a tag switched on later on the same page
  // (only Statistik first, Marketing afterwards)
  ['ga4', 'clarity', 'meta'].forEach(function (dest) {
    if (ready[dest] && !pageSent[dest]) {
      pageSent[dest] = true;
      pageEvents.forEach(function (e) { track(e.name, e.params, dest); });
    }
  });
};

var metaParams = function (p) {
  var out = {};
  if (p.value != null) { out.value = p.value; out.currency = p.currency || 'EUR'; }
  if (p.items) {
    out.content_ids = p.items.map(function (i) { return i.item_id; });
    out.content_type = 'product';
    out.num_items = p.items.reduce(function (n, i) { return n + (i.quantity || 1); }, 0);
  }
  return out;
};

function track(name, params, only) {
  if (!cfg) return;
  var to = function (dest) { return !only || only === dest; };
  params = params || {};
  if (cfg.dry) console.info('[tracking]', name, params, on);
  if (to('ga4') && on.analytics && ready.ga4) window.gtag('event', name, Object.assign({ send_to: cfg.ga4 }, params));
  // Clarity: every event by name, so recordings can be filtered by it
  if (to('clarity') && on.analytics && ready.clarity) window.clarity('event', name);
  if (to('meta') && on.marketing && ready.meta && META_EVENTS[name]) {
    // the order number = the Conversions API's event_id: Meta counts the purchase once
    var id = params.transaction_id ? { eventID: params.transaction_id } : {};
    window.fbq('track', META_EVENTS[name], metaParams(params), id);
  }
}

function start() {
  if (!cfg) return;
  var categories = { necessary: { enabled: true, readOnly: true } };
  var sections = [
    { title: 'Deine Wahl',
      description: 'Hier entscheidest du, was wir außer dem Nötigsten einsetzen dürfen. Ohne Zustimmung funktioniert alles genauso. Du kannst deine Wahl jederzeit unten auf der Seite unter „Cookie-Einstellungen“ ändern.' },
    { title: 'Notwendig <span class="pm__badge">Immer an</span>', linkedCategory: 'necessary',
      description: 'Deine Sitzung (sie ordnet dir deine Bücher zu), der Schutz vor gefälschten Formularen und diese Auswahl. Ohne sie gehen Buch, Kasse und Anmeldung nicht.' },
  ];
  var stats = [];
  if (cfg.ga4) stats.push('Google Analytics zeigt uns, welche Seiten besucht werden und wo es hakt – etwa wie viele Bücher entstehen und wie viele davon gekauft werden.');
  if (cfg.clarity) stats.push('Microsoft Clarity zeigt, wie die Seite benutzt wird (Klicks, Scrollen, Mausbewegungen), damit wir sehen, wo jemand nicht weiterkommt. Bücher, Fotos, Namen und Eingaben werden dabei verdeckt.');
  var who = [cfg.ga4 && 'Google Ireland Ltd.', cfg.clarity && 'Microsoft Ireland Operations Ltd.'].filter(Boolean).join(', ');
  if (cfg.ga4 || cfg.clarity) {
    categories.analytics = { autoClear: { cookies: [{ name: /^_ga/ }, { name: '_gid' }, { name: /^_cl(ck|sk)$/ }], reloadPage: true } };
    sections.push({ title: 'Statistik', linkedCategory: 'analytics',
      description: stats.join(' ') + ' Anbieter: ' + who + '; Daten können in die USA übertragen werden.' });
  }
  if (cfg.meta) {
    categories.marketing = { autoClear: { cookies: [{ name: '_fbp' }, { name: '_fbc' }], reloadPage: true } };
    sections.push({ title: 'Marketing', linkedCategory: 'marketing',
      description: 'Meta (Facebook, Instagram) misst, ob unsere Anzeigen zu gekauften Büchern führen, und zeigt sie Leuten, die sich dafür interessieren könnten.' +
        (cfg.capi ? ' Nach einer Bestellung melden wir sie mit gehashter E-Mail-Adresse und Bestellwert auch direkt an Meta – nur wenn du hier zustimmst.' : '') +
        ' Fotos, Namen und Bücher sieht Meta nie. Anbieter: Meta Platforms Ireland Ltd.; Daten können in die USA übertragen werden.' });
  }
  sections.push({ title: 'Mehr dazu', description: 'Alles Weitere steht in unserer <a href="' + cfg.privacy + '">Datenschutzerklärung</a>.' });
  var services = [cfg.ga4 && 'Google Analytics', cfg.clarity && 'Microsoft Clarity'].filter(Boolean).join(' und ');
  var intro = cfg.meta
    ? 'Wir möchten sehen, wie Mein Heldenkind genutzt wird und welche Werbung wirkt – mit Diensten von ' +
      [cfg.ga4 && 'Google', cfg.clarity && 'Microsoft', 'Meta'].filter(Boolean).join(', ').replace(/, ([^,]*)$/, ' und $1') + '.'
    : 'Wir möchten sehen, wie Mein Heldenkind genutzt wird und wo es hakt – mit ' + services + '.';

  CookieConsent.run({
    revision: cfg.revision,
    cookie: { name: 'cc_cookie', expiresAfterDays: 182, sameSite: 'Lax' },
    guiOptions: {
      // as TrumpfBlatt and weilsjedermacht (Dennis, 2026-10-15): ONE button "Alle akzeptieren",
      // "Einstellungen anpassen" a quiet link beneath it (the choices are in there); centred over a
      // dimmed page, so it reads as a decision to make
      consentModal: { layout: 'box', position: 'middle center', equalWeightButtons: false, flipButtons: false },
      preferencesModal: { layout: 'box', equalWeightButtons: false, flipButtons: false },
    },
    disablePageInteraction: true,
    categories: categories,
    onConsent: apply,
    onChange: apply,
    language: {
      default: 'de',
      translations: {
        de: {
          consentModal: {
            title: 'Dürfen wir mitzählen?',
            description: intro + ' Das passiert nur, wenn du zustimmst; ohne geht alles genauso. Fotos und Bücher sehen diese Dienste nie. <a href="' + cfg.privacy + '">Datenschutz</a>',
            acceptAllBtn: 'Alle akzeptieren',
            showPreferencesBtn: 'Einstellungen anpassen',
          },
          preferencesModal: {
            title: 'Cookie-Einstellungen',
            acceptAllBtn: 'Alle akzeptieren',
            savePreferencesBtn: 'Auswahl speichern',
            closeIconLabel: 'Schließen',
            sections: sections,
          },
        },
      },
    },
  });
}

module.exports = { start: start, track: track };
